'use strict';

module.exports = require('./es2016');



// WEBPACK FOOTER //
// ./node_modules/es-abstract/es7.js